import React, { useState } from 'react';
import './OurPrograms.css';

const OurPrograms = () => {
  const [filter, setFilter] = useState('*');

  const handleFilterChange = (filter) => {
    setFilter(filter);
  };

  const programs = [
    {
      id: 1,
      category: 'daycare',
      title: 'Daycare',
      age: ' 1 to 12 Years',
      timing: ' 8.30am to 6pm',
      description: 'The Day Care is offered as a value added service in a structured and detailed manner for children enrolled into Sai Shanti Vidya Niketan school as well as for children from other schools. Our Daycare is very homely and we customize our services to suit the needs of the child. Meals options are available.'
    },
    {
      id: 2,
      category: 'daycare',
      title: 'Daycare',
      age: ' 1 to 3 Years',
      timing: ' 9.30am to 4pm',
      description: 'Sai Shanti Vidya Niketan Daycare provides a nurturing and homely environment for children, making it a trusted choice for both students of our school and those from other schools. Our facility is designed to offer personalized care and a structured routine that supports the developmental needs of children aged 1 to 3 years..'
    },
    {
      id: 3,
      category: 'daycare',
      title: 'Daycare',
      age: ' 4 to 9 Years',
      timing: ' 9.30am to 5pm',
      description: 'The Day Care at Sai Shanti Vidya Niketan is an added value service designed for both children enrolled in the school and those from other institutions. Our daycare is tailored to provide a structured and detailed approach to childcare, with a focus on creating a homely atmosphere that caters to the individual needs of each child.'
    },
    {
      id: 4,
      category: 'playgroup',
      title: 'Toddlers',
      age: ' 1.10 Years Onwards',
      description: 'Our Toddler program is based on solid research on early childhood education & child development. Toddlers explore their rich classroom environment, building speech, language skills, practical life skills, fine & gross motor skills.'
    },
    {
      id: 5,
      category: 'playgroup',
      title: 'Playgroup',
      age: ' 2.5 Years Onwards',
      description: 'The curriculum sets out what every child should know and learn during their first 12 months of schooling. The focus is on physical and social development required for the child and also development of their speaking and listening skills. Each child’s need is considered to ensure age appropriate progress. This program also helps the children to become familiar with the learning process of each area of MAAP and better prepare them for progression to Nursery.'
    },
    {
      id: 6,
      category: 'playgroup',
      title: 'Nursery',
      age: ' 3.3 Years Onwards',
      description: 'The curriculum is common set of knowledge and skills required by the students for lifelong learning that have lifetime implications. Throughout this age range, children continue to grow emotionally and socially. The children of this age group learn best through active and play based learning.'
    },
    {
      id: 7,
      category: 'playgroup',
      title: 'Pre Nursery',
      age: ' 2.3 Years Onwards',
      description: 'The Pre-Nursery program at Sai Shanti Vidya Niketan is thoughtfully designed to provide a stimulating and nurturing environment for young learners, aged 2 to 3 years. Our program focuses on fostering the early development of social, emotional, cognitive, and physical skills, laying a strong foundation for future learning.'

    },
    {
      id: 8,
      category: 'kindergarten',
      title: 'LKG',
      age: ' 4 Years Onwards',
      description: 'The program encourages children’s learning interest and recognition of uniqueness of each child and helps nurture an eagerness to learn as well. The aim is to foster love for learning from an early age.'
    },
    {
      id: 9,
      category: 'kindergarten',
      title: 'LKG',
      age: ' 4.5 Years Onwards',
      description: 'The Lower Kindergarten (LKG) program at Sai Shanti Vidya Niketan is designed to cater to children aged 4 to 5 years, focusing on their holistic development and preparing them for more structured learning in the years to come. Our LKG program balances academic learning with play, ensuring children enjoy a comprehensive and engaging educational experience.'
    },
    {
      id: 10,
      category: 'kindergarten',
      title: 'UKG',
      age: ' 5 Years Onwards',
      description: 'The curriculum is designed with an emphasis on importance of preschool learning in laying the foundation for future. It reflects Sai Shanti Vidya Niketan standards and incorporates Motor Skills, Language, Arts, Numeracy and Life Skills. The central aim is to close the gap in children’s preparedness for formal education to grade one.'
    },
    {
      id: 11,
      category: 'kindergarten',
      title: 'UKG',
      age: ' 5.6 Years Onwards',
      description: 'The Upper Kindergarten (UKG) program at Sai Shanti Vidya Niketan is designed for children aged 5 to 6 years. This program aims to provide a smooth transition from early childhood education to primary schooling. With a focus on developing foundational academic skills and promoting social, emotional, and physical growth, our UKG curriculum ensures that children are well-prepared for their future educational journey.'
    },
  ];

  return (
    <div>
      <div className="page-section" data-bg="images/1920x993_bg.jpg" style={{ backgroundImage: 'url(images/1920x993_bg.jpg)' }}>
        <div className="container">
          <div className="align-center">
            <h2 className="section-title type2">Our Programs</h2>
          </div>

          <div id="options">
            <div id="filters" className="isotope-nav">
              <button className={filter === '*' ? 'is-checked' : ''} onClick={() => handleFilterChange('*')}>All Classes</button>
              <button className={filter === 'daycare' ? 'is-checked' : ''} onClick={() => handleFilterChange('daycare')}>Day Care</button>
              <button className={filter === 'playgroup' ? 'is-checked' : ''} onClick={() => handleFilterChange('playgroup')}>Play Group</button>
              <button className={filter === 'kindergarten' ? 'is-checked' : ''} onClick={() => handleFilterChange('kindergarten')}>Kindergarten</button>
            </div>
          </div>

          <div className="isotope">
            {programs.map(program => (
              (filter === '*' || filter === program.category) && (
                <div key={program.id} className={`item ${program.category} visible`}>
                  <div className="welcome-item">
                    <div className="welcome-inner">
                      {/* <div className="welcome-img">
                        <img src={program.image} alt={program.title} />
                      </div> */}
                      <div className="welcome-content">
                        <div className="entry">
                          <div className="entry-body">
                            <h5 className="entry-title">
                              <a href="#">{program.title}</a>
                            </h5>
                            <p>{program.description}</p>
                          </div>
                          <div className="class-info">
                            <div className="class-age">
                              <span>Age</span>
                              {program.age}
                            </div>
                            {program.timing && (
                              <div className="class-size">
                                <span>Timing</span>
                                {program.timing}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurPrograms;